<div class="terms-container">
    <h1>Terms of Service</h1>

    <p>Last updated: January 31, 2026</p>

    <h2>1. Acceptance of Terms</h2>
    <p>
        By accessing and using this website, you accept and agree to be bound by the terms and provision of this
        agreement.
    </p>

    <h2>2. Use of Service</h2>
    <p>
        You need to use this service for lawful purposes only and in a way that does not infringe the rights of,
        restrict or inhibit anyone else's use and enjoyment of this website.
    </p>

    <h2>3. Disclaimer</h2>
    <p>
        The materials on this website are provided on an 'as is' basis. We make no warranties, expressed or implied, and
        hereby disclaim and negate all other warranties including, without limitation, implied warranties or conditions
        of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other
        violation of rights.
    </p>
</div>